"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultComponents = exports.Step = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var overrides_1 = require("../../util/overrides");
var CheckDefault_1 = __importDefault(require("../Icon/generated/CheckDefault"));
function Step(props) {
    var status = props.status, hasConnector = props.hasConnector, style = props.style, overrides = props.overrides, children = props.children, rest = __rest(props, ["status", "hasConnector", "style", "overrides", "children"]);
    var _a = overrides_1.getComponents(overrides, exports.defaultComponents), Root = _a.Root, Icon = _a.Icon, IconContainer = _a.IconContainer, Connector = _a.Connector, Label = _a.Label;
    var _b = styles_1.useStyles(createStyles, props), classes = _b.classes, css = _b.css;
    return (react_1.default.createElement(Root, __assign({ className: css(classes.step, style) }, rest),
        hasConnector && react_1.default.createElement(Connector, { className: css(classes.connector) }),
        react_1.default.createElement(IconContainer, { className: classes.iconContainer },
            Icon && react_1.default.createElement(Icon, { className: classes.icon }),
            !Icon && status === 'completed' && react_1.default.createElement(CheckDefault_1.default, { className: classes.icon })),
        react_1.default.createElement(Label, { className: classes.stepLabel }, children)));
}
exports.Step = Step;
Step.defaultProps = {
    status: 'incompleted',
    hasConnector: true,
};
exports.defaultComponents = {
    Root: 'span',
    Icon: null,
    IconContainer: 'span',
    Connector: 'span',
    Label: 'span',
};
var createStyles = function (theme, _a) {
    var status = _a.status;
    return ({
        step: {
            position: 'relative',
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            padding: '0 0.5rem',
        },
        connector: {
            position: 'absolute',
            top: '0.5rem',
            left: 'calc(-50% + 0.5rem)',
            right: 'calc(50% + 0.5rem)',
            borderTopWidth: '2px',
            borderTopStyle: 'solid',
            borderTopColor: status === 'incompleted' ? theme.pallete.gray.c80 : theme.pallete.primary.main,
            transition: 'all .4s ease',
        },
        iconContainer: {
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '1rem',
            height: '1rem',
            borderRadius: '50%',
            background: status === 'incompleted' ? theme.pallete.gray.c80 : theme.pallete.primary.main,
            textAlign: 'center',
            marginBottom: '0.75rem',
            transition: 'all .4s ease',
            boxShadow: (status === 'active' && styles_1.focusBoxShadow(theme, 'primary')) ||
                (status === 'completed' && "0 0 0 4px " + theme.pallete.primary.main),
        },
        icon: {
            fill: theme.pallete.primary.c100,
            width: '1rem',
            height: '1rem',
        },
        stepLabel: {
            fontWeight: 'bold',
            color: status === 'active' && theme.pallete.primary.main,
            transition: 'all .4s ease',
        },
    });
};
//# sourceMappingURL=Step.js.map